import { EvaluateStudent } from '@/plugins/api'

export default {
  namespaced: true,

  state: {
    evaluateStudents: [],
    currentEvaluateStudent: null,
    totalEvaluateStudents: 0,
    loading: false,
    error: null,
  },

  mutations: {
    SET_EVALUATE_STUDENTS(state, evaluateStudents) {
      state.evaluateStudents = evaluateStudents
    },
    SET_CURRENT_EVALUATE_STUDENT(state, evaluateStudent) {
      state.currentEvaluateStudent = evaluateStudent
    },
    SET_TOTAL_EVALUATE_STUDENTS(state, total) {
      state.totalEvaluateStudents = total
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_EVALUATE_STUDENT(state, evaluateStudent) {
      state.evaluateStudents.push(evaluateStudent)
    },
    UPDATE_EVALUATE_STUDENT(state, updatedEvaluateStudent) {
      const index = state.evaluateStudents.findIndex((es) => es.id === updatedEvaluateStudent.id)
      if (index !== -1) {
        state.evaluateStudents.splice(index, 1, updatedEvaluateStudent)
      }
    },
    REMOVE_EVALUATE_STUDENT(state, id) {
      state.evaluateStudents = state.evaluateStudents.filter((es) => es.id !== id)
    },
  },

  actions: {
    async fetchEvaluateStudents({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const response = await EvaluateStudent.fetch(params)
        commit('SET_EVALUATE_STUDENTS', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchEvaluateStudent({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        const response = await EvaluateStudent.fetchOne(id)
        commit('SET_CURRENT_EVALUATE_STUDENT', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createEvaluateStudent({ commit }, evaluateStudentData) {
      commit('SET_LOADING', true)
      try {
        const response = await EvaluateStudent.create(evaluateStudentData)
        commit('ADD_EVALUATE_STUDENT', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateEvaluateStudent({ commit }, { id, data }) {
      commit('SET_LOADING', true)
      try {
        const response = await EvaluateStudent.update(id, data)
        commit('UPDATE_EVALUATE_STUDENT', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteEvaluateStudent({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        await EvaluateStudent.remove(id)
        commit('REMOVE_EVALUATE_STUDENT', id)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createOrUpdateEvaluateStudent({ commit }, data) {
      commit('SET_LOADING', true)
      try {
        const response = await EvaluateStudent.createOrUpdate(data)
        if (data.id) {
          commit('UPDATE_EVALUATE_STUDENT', response)
        } else {
          commit('ADD_EVALUATE_STUDENT', response)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async countEvaluateStudents({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const count = await EvaluateStudent.count(params)
        commit('SET_TOTAL_EVALUATE_STUDENTS', count)
        return count
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },

  getters: {
    getEvaluateStudents: (state) => state.evaluateStudents,
    getCurrentEvaluateStudent: (state) => state.currentEvaluateStudent,
    getTotalEvaluateStudents: (state) => state.totalEvaluateStudents,
    getLoading: (state) => state.loading,
    getError: (state) => state.error,
  },
}
